import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'enumToArray'
  })
  export class EnumToArrayPipe implements PipeTransform {
    transform(data: Object) {
      let keys = Object.keys(data);
      let keysToReturn = keys.slice(0, keys.length / 2) as any[];
      keysToReturn.forEach(key => {
        if(!isNaN(parseInt(key))) {
            keysToReturn[key] = parseInt(key);
        }
      });
      return keysToReturn;
    }
  }